// extracted by mini-css-extract-plugin
module.exports = {"noSelect":"style_noSelect_3-bo_"};